import React, { useState, useEffect } from 'react';
import { planService } from '../../services/planService';
import { useLanguage } from '../../contexts/LanguageContext';
import { Eye, Plus, Star } from 'lucide-react';

const PlanList = ({ onPlanSelect, onCreateNew }) => {
    const { t } = useLanguage();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            setLoading(true);
            const response = await planService.getAllPlans();
            if (response.success) setPlans(response.data.plans || []);
        } catch (error) {
            console.error(t('loadUsersError'), error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <div>{t('loading')}</div>
            </div>
        );
    }

    return (
        <div className="plan-management">
            <div className="page-header">
                <h1>{t('planManagement')}</h1>
                <p>{t('planManagementDescription')}</p>
            </div>

            <div className="users-content">
                <div className="users-table-container">
                    <div className="table-header">
                        <h2>{t('allPlans')}</h2>
                        <div className="table-actions">
                            <button className="view-btn" onClick={onCreateNew}>
                                <Plus size={16} /> {t('newPlan')}
                            </button>
                        </div>
                    </div>

                    <table className="users-table">
                        <thead>
                            <tr>
                                <th>{t('sortOrder')}</th>
                                <th>{t('nameTr')}</th>
                                <th>{t('nameEn')}</th>
                                <th>{t('monthlyTry')}</th>
                                <th>{t('yearlyTry')}</th>
                                <th>{t('monthlyUsd')}</th>
                                <th>{t('status')}</th>
                                <th>{t('actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {plans.map(plan => (
                                <tr key={plan.id}>
                                    <td>{plan.sortOrder}</td>
                                    <td>{plan.nameTr} {plan.isPopular && <Star size={13} fill="#f59e0b" color="#f59e0b" />}</td>
                                    <td>{plan.nameEn}</td>
                                    <td>{plan.monthlyPriceTry}</td>
                                    <td>{plan.yearlyPriceTry}</td>
                                    <td>{plan.monthlyPriceUsd}</td>
                                    <td>
                                        <span className={`status-toggle ${plan.isActive ? 'active' : 'inactive'}`}>
                                            {plan.isActive ? t('active') : t('inactive')}
                                        </span>
                                        {plan.isSystem && <span style={{ marginLeft: 6, fontSize: 11, color: '#94a3b8' }}>({t('systemPlan')})</span>}
                                    </td>
                                    <td>
                                        <div className="user-actions">
                                            <button className="view-btn" onClick={() => onPlanSelect(plan)} title={t('editPlan')}>
                                                <Eye size={14} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {plans.length === 0 && <div className="no-data"><p>{t('noPlansFound')}</p></div>}
                </div>
            </div>
        </div>
    );
};

export default PlanList;
